export default {
    getEEAStatus() {
        const initialData = {
            event: 'initialDataLayerData',
            b9e1a58e5807: 2
        };
        return fetch('https://1706.codewise.com')
            .then((response) => {
                if (!response.ok) {
                    return initialData;
                }
                return response;
            })
            .then(data => data.json())
            .then((json) => {
                initialData.b9e1a58e5807 = json.b9e1a58e5807;
                return initialData;
            })
            .catch(() => {
                return initialData;
            });
    }
};



// WEBPACK FOOTER //
// ./src/services/EEAService.js